import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getChecklistApplicationAvailableColumns, getDefectTypeList } from './api';

export const path = '/checklist/application/list';

const PageChecklistApplicationList: React.FC = (props) => {
  const ChecklistApplication = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getChecklistApplicationAvailableColumns,
      defectTypes: getDefectTypeList,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <ChecklistApplication {...props} />;
};

export default PageChecklistApplicationList;
